module.exports = "../../../../platform/assets/pageMainIcon/simple_yewushezhilei6.svg";